import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _extends from "@swc/helpers/src/_extends.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button } from "./Button";
import clsx from "clsx";
import { signIn, useSession } from "next-auth/react";
import { useState } from "react";
export function GoogleLoginButton(_param) {
    var tmp = _param.callbackPath, callbackUrl = tmp === void 0 ? "/dashboard" : tmp, _className = _param.className, className = _className === void 0 ? "" : _className, _text = _param.text, text = _text === void 0 ? "Continue with Google" : _text, _showEmailSignIn = _param.showEmailSignIn, showEmailSignIn = _showEmailSignIn === void 0 ? false : _showEmailSignIn, _fingerprint = _param.fingerprint, fingerprint = _fingerprint === void 0 ? "" : _fingerprint, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _textColor = _param.textColor, textColor = _textColor === void 0 ? "white" : _textColor, rest = _object_without_properties(_param, [
        "callbackPath",
        "className",
        "text",
        "showEmailSignIn",
        "fingerprint",
        "disabled",
        "textColor"
    ]);
    var ref = useSession(), session = ref.data;
    var ref1 = useState(false), isLoading = ref1[0], setIsLoading = ref1[1];
    return /*#__PURE__*/ _jsx("div", {
        className: clsx("flex flex-col"),
        children: /*#__PURE__*/ _jsxs("div", {
            className: "",
            children: [
                /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
                    bg: "blue.500",
                    bgDark: "blue.500",
                    biggerOnHover: true,
                    className: clsx("!px-5 text-white w-full", !disabled && "hover:bg-blue-300", className),
                    style: {
                        minWidth: text.length + 2 + "ch"
                    },
                    disabled: disabled,
                    isLoading: isLoading,
                    "aria-label": "login with google",
                    // bg='#0597FF'
                    onClick: /*#__PURE__*/ _async_to_generator(function() {
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    setIsLoading(true);
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        ,
                                        3,
                                        4
                                    ]);
                                    return [
                                        4,
                                        signIn("google", {
                                            callbackUrl: new URL(callbackUrl, window.location.href).toString()
                                        }, {
                                            prompt: "select_account"
                                        })
                                    ];
                                case 2:
                                    _state.sent();
                                    return [
                                        3,
                                        4
                                    ];
                                case 3:
                                    setIsLoading(false);
                                    return [
                                        7
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })
                }, rest), {
                    children: /*#__PURE__*/ _jsx("div", {
                        className: clsx("tracking-wide space-x-2 justify-center items-center font-bold", "flex-row flex"),
                        style: {
                            color: textColor
                        },
                        children: disabled ? /*#__PURE__*/ _jsx("div", {
                            className: "",
                            children: "Logged in"
                        }) : /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(GoogleIcon, {
                                    className: "block w-5 h-5 fill-current"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "truncate",
                                    children: text
                                })
                            ]
                        })
                    })
                })),
                showEmailSignIn && /*#__PURE__*/ _jsx("button", _object_spread_props(_object_spread({
                    onClick: function() {
                        signIn(undefined, {
                            callbackUrl: callbackUrl
                        });
                    },
                    className: "w-full text-center md:text-left appearance-none underline font-medium opacity-50 active:opacity-30 text-sm mt-3"
                }, rest), {
                    children: "Continue with email instead"
                })),
                fingerprint && /*#__PURE__*/ _jsx("div", {
                    className: "opacity-60 text-sm font-medium mt-3 w-full text-left",
                    children: fingerprint
                })
            ]
        })
    });
}
function GoogleIcon(_param) {
    var rest = _extends({}, _param);
    return /*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30"
    }, rest), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M 15.003906 3 C 8.3749062 3 3 8.373 3 15 C 3 21.627 8.3749062 27 15.003906 27 C 25.013906 27 27.269078 17.707 26.330078 13 L 25 13 L 22.732422 13 L 15 13 L 15 17 L 22.738281 17 C 21.848702 20.448251 18.725955 23 15 23 C 10.582 23 7 19.418 7 15 C 7 10.582 10.582 7 15 7 C 17.009 7 18.839141 7.74575 20.244141 8.96875 L 23.085938 6.1289062 C 20.951937 4.1849063 18.116906 3 15.003906 3 z"
        })
    }));
}
